// TODO (webpack v5): drop the `build/package/` part of these import paths.
// Snabbdom>=1 uses the package.json#exports field that webpack v4 doesn't know
// about
//
// https://github.com/webpack/webpack/issues/9509
// https://webpack.js.org/guides/package-exports/
import {init} from 'snabbdom/build/package/init';
import {classModule} from 'snabbdom/build/package/modules/class';
import {styleModule} from 'snabbdom/build/package/modules/style';
import {eventListenersModule} from 'snabbdom/build/package/modules/eventlisteners';
import {datasetModule} from 'snabbdom/build/package/modules/dataset';
import {denyUnlessSigned} from 'snabbdom-signature';
import {ref, props, attributes} from '../modules';

const patch = init([
	props,
	classModule,
	styleModule,
	eventListenersModule,
	attributes,
	datasetModule,
	ref,
	denyUnlessSigned
]);

export default patch;
